import unescape from 'lodash/unescape'
import { getName } from '@/utils/profile'

export default class ActiveProfile {
  id?: number | null
  first_name: string | null
  last_name: string | null

  constructor(data: LX.ActiveProfile) {
    this.id = data.id || data.user_id
    this.first_name = unescape(data.first_name || '')
    this.last_name = unescape(data.last_name || '')
  }

  static fromServer(data: LX.ActiveProfile) {
    return new ActiveProfile(data)
  }

  get name() {
    return getName(this)
  }
}
